import { map } from "lodash/collection"

export const licenseDefinitions = {
  adaptC: {
    descriptionId: "licenseDefinitionAdaptC",
    titleId: "licenseAdaptC"
  },
  adapt: {
    descriptionId: "licenseDefinitionAdapt",
    titleId: "licenseAdapt",
  },
  attribution: {
    descriptionId: "licenseDefinitionAttribution",
    titleId: "licenseAttribution"
  },
  noAdditional: {
    descriptionId: "licenseDefinitionNoAdditional",
    titleId: "licenseNoAdditional"
  },
  noDerivatives: {
    titleId: "licenseNoDerivatives",
    descriptionId: "licenseDefinitionNoDerivatives",
  },
  nonCommercial: {
    titleId: "licenseNonCommercial",
    descriptionId: "licenseDefinitionNonCommercial"
  },
  contact: {
    titleId: "licenseContact",
    descriptionId: "licenseDefinitionContact"
  },
  shareNC: {
    titleId: "licenseShareNC",
    descriptionId: "licenseDefinitionShareNC"
  },
  share: {
    titleId: "licenseShare",
    descriptionId: "licenseDefinitionShare"
  }
}

export const licenseTypes = [
  {
    name: "no_known_restrictions",
    label: "licenseNoKnownRestrictions",
    description: "licenseNoKnownRestrictions"
  },
  {
    name: "some_restrictions_apply",
    label: "licenseSomeRestrictionsMayApply",
    copyright: true,
    description: "licenseDescriptionSomeRestrictionsMayApply"
  },
  {
    name: "contact_us",
    label: "licenseContactUsForDetails",
    copyright: true,
    description: "licenseDescriptionContactUsForDetails"
  },
  { 
    name: "copyright",
    label: "licenseCopyright",
    copyright: true
  },
  {
    name: "cc-by",
    label: "licenseByAttributionAlone",
    definitions: ["share", "adapt", "attribution", "noAdditional"],
    url: "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    name: "cc-by-sa",
    label: "licenseAttributionShareAlike",
    definitions: ["share", "adapt", "attribution", "share", "noAdditional"],
    url: "https://creativecommons.org/licenses/by-sa/4.0/",
    description: "licenseDescriptionAttributionShareAlike"
  },
  {
    name: "cc-by-nd",
    label: "licenseAttributionNoDerivatives",
    definitions: ["share", "attribution", "noDerivatives", "noAdditional"],
    url: "https://creativecommons.org/licenses/by-nd/4.0/"
  },
  {
    name: "cc-by-nc",
    label: "licenseAttributionNonCommercial",
    definitions: [
      "share",
      "adapt",
      "attribution",
      "nonCommercial",
      "noAdditional"
    ],
    url: "https://creativecommons.org/licenses/by-nc/4.0/"
  },
  {
    name: "cc-by-nc-sa",
    label: "licenseAttributionNonCommercialShareAlike",
    definitions: [
      "shareNC",
      "adapt",
      "attribution",
      "nonCommercial",
      "noAdditional"
    ],
    url: "https://creativecommons.org/licenses/by-nc-sa/4.0/"
  },
  {
    name: "cc-by-nc-nd",
    label: "licenseAttributionNonCommercialNoDerivatives",
    definitions: [
      "share",
      "attribution",
      "nonCommercial",
      "noDerivatives",
      "noAdditional"
    ],
    url: "https://creativecommons.org/licenses/by-nc-nd/4.0/"
  },
  {
    name: "cc0",
    label: "licensePublicDomainDedication",
    url: "https://creativecommons.org/publicdomain/zero/1.0/",
    description: "licenseDescriptionPublicDomainDedication"
  }
]

export const licenseNames = map(licenseTypes, "name")



// WEBPACK FOOTER //
// ./webapp/scripts/licenseTypes.js